(() => {
  const openDialogs = new Set();
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-kn-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.knOpen);
      if (!dialog) return;
      dialog.showModal();
      openDialogs.add(dialog);
      document.documentElement.classList.add('kn-dialog-open');
      dialog.addEventListener('close', () => {
        openDialogs.delete(dialog);
        if (!openDialogs.size) document.documentElement.classList.remove('kn-dialog-open');
        trigger.focus();
      }, {once:true});
    }
    const closer = event.target.closest('[data-kn-close]');
    if (closer) closer.closest('dialog').close();
    if (event.target.matches('.kn-dialog')) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
    if (event.target.closest('.kn-mobile-nav a')) event.target.closest('details').open = false;
  });
})();


if (!customElements.get('kinetic-routines')) {
  customElements.define('kinetic-routines', class extends HTMLElement {
    connectedCallback() {
      if (this.routinesReady) return;
      this.routinesReady = true;
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      const panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
        document.dispatchEvent(new Event('kinetic:panel-change'));
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(next, true); }
        });
      });
    }
  });
}
if (!customElements.get('kinetic-timeline')) {
  customElements.define('kinetic-timeline', class extends HTMLElement {
    connectedCallback() {
      this.steps = Array.from(this.querySelectorAll('.kn-timeline-step'));
      this.updateFocus = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (!this.getClientRects().length) return;
          const target = window.innerHeight * 0.46;
          const active = this.steps.reduce((best, step) => {
            const rect = step.getBoundingClientRect();
            const distance = Math.abs(rect.top + Math.min(rect.height, 100) / 2 - target);
            return !best || distance < best.distance ? {step, distance} : best;
          }, null);
          this.steps.forEach(step => step.classList.toggle('is-active', step === active?.step));
        });
      };
      window.addEventListener('scroll', this.updateFocus, {passive:true});
      window.addEventListener('resize', this.updateFocus);
      document.addEventListener('kinetic:panel-change', this.updateFocus);
      this.updateFocus();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.updateFocus);
      window.removeEventListener('resize', this.updateFocus);
      document.removeEventListener('kinetic:panel-change', this.updateFocus);
      cancelAnimationFrame(this.frame);
    }
  });
}

if (!customElements.get('kinetic-reveal')) {
  customElements.define('kinetic-reveal', class extends HTMLElement {
    connectedCallback() {
      if (this.revealReady) return;
      this.revealReady = true;
      const range = this.querySelector('input[type="range"]');
      const update = () => this.style.setProperty('--reveal', `${range.value}%`);
      range.addEventListener('input', update);
      this.querySelectorAll('[data-reveal-value]').forEach(button => {
        button.addEventListener('click', () => {
          range.value = button.dataset.revealValue;
          update();
        });
      });
      update();
    }
  });
}

(() => {
 const field = document.getElementById('kn-message');
 const product = new URLSearchParams(location.search).get('produit');
 if (field && product && !field.value) field.value = `Bonjour, je souhaite être informé(e) de l’ouverture des ventes pour ${product.slice(0, 120)}. Merci !`;
})();
